module.exports = __webpack_public_path__ + "img/2c2eff53b5afd43302bdbcf8168995f9.png";